module.exports = __webpack_public_path__ + "static/media/arrow_disabled.585e6af8.svg";